
export default class AdfFilters {

    constructor() {
        const isFilters = document.querySelector('body:not(.articles-page) aside.filters');

        if (isFilters === null) {

            return;
        }

        //this.bindEvents();
    }

    bindEvents() {
        const filtersToggle = document.querySelectorAll('.filters-toggle-btn');
        const arrFiltersToggle = Array.from(filtersToggle)

        arrFiltersToggle.forEach((el) => {
            el.addEventListener('click', this.toggleFiltersList);
        });

        //
        const resetFilters = document.querySelector('.filters-reset');
        resetFilters.addEventListener('click', this.resetFilters.bind(this));

        //
        const expandFilters = document.querySelector('.filters-expand');
        if(expandFilters !== null){
            expandFilters.addEventListener('click', this.expandFilters);
        }


        //
        const filters = document.querySelectorAll('.filter-group input[type="checkbox"]');
        const arrFilters = Array.from(filters);

        arrFilters.forEach((filter) => {
            filter.addEventListener('change', this.toggleFilter.bind(this));
        });
    }

    toggleFiltersList() {
        const filters = document.querySelector('.filters');

        console.log('toggleFiltersList', filters)

        if (filters.classList.contains('closed')) {
            filters.classList.remove('closed');
            setTimeout(() => {
                filters.classList.remove('closing');
            }, 20);
        } else {
            filters.classList.add('closing');
            setTimeout(() => {
                filters.classList.add('closed');
            }, 200);
        }
    }

    resetFilters() {
        const filtersCheckbox = document.querySelectorAll('[id^="category-filter-checkbox"]');
        const arrFiltersCheckbox = Array.from(filtersCheckbox);

        arrFiltersCheckbox.forEach((checkbox) => {
            checkbox.checked = false;
        });

        this.collapseFilters();
    }

    collapseFilters(){
        const filterGroup = document.querySelectorAll('.filter-group.has-children');
        const arrFilterGroup = Array.from(filterGroup);

        arrFilterGroup.forEach((fg) => {
            fg.classList.remove('opened');
        })
    }

    expandFilters() {
        const filterGroup = document.querySelectorAll('.filter-group.has-children');
        const arrFilterGroup = Array.from(filterGroup);

        arrFilterGroup.forEach((fg) => {
            fg.classList.add('opened');
        })
    }

    toggleFilter(event) {
        const checkbox = event.target;
        const filterGroup = checkbox.parentNode.parentNode.parentNode;

        if(checkbox.checked){
            //this.checkParent(checkbox);
        }

        if (filterGroup.classList.contains('has-children') && checkbox.checked) {
            filterGroup.classList.add('opened');
            //this.checkParent(checkbox);
        } /*else if (filterGroup.classList.contains('has-children') && !checkbox.checked) {
            filterGroup.classList.remove('opened');
        }*/
    }

    checkParent(checkbox){
        const filterGroup = checkbox.parentNode.parentNode.parentNode;

        if(filterGroup.classList.contains('has-children')){
            let parentCheckbox = filterGroup.querySelector('.checkbox-group input[type="checkbox"]');
            parentCheckbox.checked = true;

            this.checkParent(parentCheckbox);
        }
    }
}
